import { TicketSortPickerPopover } from "@jugl-web/domain-resources/tickets/components/TicketSortPickerPopover";
import { HeaderIconButton } from "@web-src/modules/client-support/components/HeaderIconButton";
import { useTicketsViewContext } from "@web-src/modules/client-support/pages/ClientSupportPage/providers/TicketsViewProvider";
import { FC } from "react";
import { ReactComponent as SortIcon } from "./assets/sort.svg";

export const TicketsViewSortButton: FC = () => {
  const { sort, setSort } = useTicketsViewContext();

  return (
    <TicketSortPickerPopover
      sort={sort}
      onSortChange={setSort}
      renderTrigger={({ Trigger, triggerRef, isOpen }) => (
        <Trigger
          as={HeaderIconButton}
          ref={triggerRef}
          icon={<SortIcon />}
          isActive={isOpen}
        />
      )}
    />
  );
};
